[
  {
    "id": "TB-E6-001",
    "module": "Taalbegrip",
    "difficulty": 105,
    "question": "Lees de tekst:\n\n\"De octopus is een van de slimste dieren in de zee. Hij kan puzzels oplossen en potjes openmaken. Sommige octopussen gebruiken kokosnootschalen als schuilplaats.\"\n\nWat is een goede titel voor deze tekst?",
    "options": [
      "De slimme octopus",
      "Dieren in de zee",
      "Kokosnoten",
      "Puzzels oplossen"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tekstanalyse",
    "subSkill": "hoofdgedachte",
    "familyId": "TB-OCTOPUS-TITEL",
    "explanation": "De tekst gaat over hoe slim de octopus is. Alle voorbeelden (puzzels, potjes, kokosnootschalen) laten dat zien.",
    "distractorExplanations": {
      "1": "Te breed — de tekst gaat specifiek over de octopus.",
      "2": "Kokosnoten zijn slechts een detail.",
      "3": "Puzzels zijn slechts een voorbeeld."
    }
  },
  {
    "id": "TB-E6-002",
    "module": "Taalbegrip",
    "difficulty": 105,
    "question": "Lees de tekst:\n\n\"Vroeger dachten mensen dat de aarde plat was. Zeelieden waren bang om van de rand te vallen. Pas toen ontdekkingsreizigers de wereld rondreisden, ontdekten ze dat de aarde rond is.\"\n\nWat dachten mensen vroeger?",
    "options": [
      "Dat de aarde plat was",
      "Dat de aarde rond was",
      "Dat de zee gevaarlijk was",
      "Dat je kon vliegen"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tekstbegrip",
    "subSkill": "letterlijk_begrip",
    "familyId": "TB-AARDE-PLAT",
    "explanation": "De eerste zin zegt: 'Vroeger dachten mensen dat de aarde plat was.'",
    "distractorExplanations": {
      "1": "Dat ontdekten ze pas later.",
      "2": "De zee wordt niet als gevaarlijk beschreven.",
      "3": "Vliegen wordt niet in de tekst genoemd."
    }
  },
  {
    "id": "TB-E6-003",
    "module": "Taalbegrip",
    "difficulty": 105,
    "question": "Lees de tekst:\n\n\"Honing wordt nooit slecht. Archeologen vonden honing in Egyptische graven die meer dan 3000 jaar oud was. De honing was nog steeds eetbaar!\"\n\nWat maakt deze tekst bijzonder?",
    "options": [
      "Honing van 3000 jaar oud was nog eetbaar",
      "Archeologen werken in Egypte",
      "Honing komt van bijen",
      "Graven zijn oud"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tekstanalyse",
    "subSkill": "conclusie_trekken",
    "familyId": "TB-HONING",
    "explanation": "Het bijzondere feit is dat honing na 3000 jaar nog steeds eetbaar was. Dat ondersteunt de eerste zin: honing wordt nooit slecht.",
    "distractorExplanations": {
      "1": "Dat is een detail, niet het bijzondere punt.",
      "2": "Dat staat niet in de tekst.",
      "3": "Dat is vanzelfsprekend."
    }
  },
  {
    "id": "TB-E6-004",
    "module": "Taalbegrip",
    "difficulty": 105,
    "question": "Wat betekent het woord 'eetbaar' in de zin: 'De honing was nog steeds eetbaar.'",
    "options": [
      "Je kunt het opeten zonder ziek te worden",
      "Het smaakt lekker",
      "Het is gemaakt van eten",
      "Het is klaar om te serveren"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "woordenschat",
    "subSkill": "woordbetekenis",
    "familyId": "TB-WOORD-EETBAAR",
    "explanation": "'Eetbaar' betekent dat je het veilig kunt eten. Het achtervoegsel '-baar' betekent 'geschikt om te'.",
    "distractorExplanations": {
      "1": "Eetbaar zegt niets over smaak.",
      "2": "Het is niet 'gemaakt van eten'.",
      "3": "Serveren is iets anders dan eetbaar zijn."
    }
  },
  {
    "id": "TB-E6-005",
    "module": "Taalbegrip",
    "difficulty": 105,
    "question": "Lees de tekst:\n\n\"De cheetah is het snelste landdier. Hij kan 120 km per uur rennen. Maar hij kan die snelheid maar kort volhouden. Na een sprint moet hij rusten.\"\n\nWat is het nadeel van de snelheid van de cheetah?",
    "options": [
      "Hij kan de snelheid maar kort volhouden",
      "Hij is niet zo snel als een auto",
      "Hij moet elke dag rennen",
      "Andere dieren zijn sneller"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tekstanalyse",
    "subSkill": "conclusie_trekken",
    "familyId": "TB-CHEETAH",
    "explanation": "Het signaalwoord 'maar' geeft een tegenstelling aan: hij is snel, MAAR kan het niet lang volhouden.",
    "distractorExplanations": {
      "1": "De tekst vergelijkt niet met auto's.",
      "2": "De tekst zegt niet dat hij elke dag moet rennen.",
      "3": "De tekst zegt dat hij het snelste landdier IS."
    }
  },
  {
    "id": "TB-E6-006",
    "module": "Taalbegrip",
    "difficulty": 105,
    "question": "Lees de tekst:\n\n\"Flamingo's zijn roze door hun voedsel. Ze eten garnalen en algen die een rode kleurstof bevatten. Als een flamingo geen garnalen eet, wordt hij langzaam wit.\"\n\nWaarom zijn flamingo's roze?",
    "options": [
      "Door de rode kleurstof in hun voedsel",
      "Omdat ze in warm water leven",
      "Omdat ze zo geboren worden",
      "Door de zon"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tekstbegrip",
    "subSkill": "letterlijk_begrip",
    "familyId": "TB-FLAMINGO",
    "explanation": "De tekst zegt: 'Flamingo's zijn roze door hun voedsel' en legt uit dat garnalen en algen rode kleurstof bevatten.",
    "distractorExplanations": {
      "1": "Warm water wordt niet als reden genoemd.",
      "2": "De tekst zegt juist dat ze wit worden zonder garnalen.",
      "3": "De zon wordt niet genoemd."
    }
  },
  {
    "id": "TB-E6-007",
    "module": "Taalbegrip",
    "difficulty": 105,
    "question": "Lees de tekst:\n\n\"In Japan buigen mensen als begroeting. In Nederland geven we een hand. In Frankrijk geven ze drie zoenen. Elk land heeft zijn eigen gewoontes.\"\n\nWat is de hoofdgedachte?",
    "options": [
      "Elk land heeft andere manieren om te begroeten",
      "Japan is een bijzonder land",
      "Zoenen geven is beter dan handen schudden",
      "Mensen begroeten elkaar altijd"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tekstanalyse",
    "subSkill": "hoofdgedachte",
    "familyId": "TB-BEGROETING",
    "explanation": "De laatste zin vat het samen: 'Elk land heeft zijn eigen gewoontes.' De voorbeelden illustreren dit.",
    "distractorExplanations": {
      "1": "Japan is slechts een voorbeeld.",
      "2": "De tekst zegt niet dat het ene beter is dan het andere.",
      "3": "Dit is te vaag en niet de kern van de tekst."
    }
  },
  {
    "id": "TB-E6-008",
    "module": "Taalbegrip",
    "difficulty": 105,
    "question": "Wat betekent het woord 'archeologen' in de tekst over honing?",
    "options": [
      "Wetenschappers die oude voorwerpen en gebouwen bestuderen",
      "Mensen die honing maken",
      "Dokters in Egypte",
      "Mensen die in graven wonen"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "woordenschat",
    "subSkill": "woordbetekenis",
    "familyId": "TB-WOORD-ARCHEOLOGEN",
    "explanation": "Archeologen zijn wetenschappers die oude beschavingen bestuderen door opgravingen te doen.",
    "distractorExplanations": {
      "1": "Dat zijn imkers.",
      "2": "Archeologen zijn geen dokters.",
      "3": "Archeologen bestuderen graven, ze wonen er niet in."
    }
  },
  {
    "id": "TB-E6-009",
    "module": "Taalbegrip",
    "difficulty": 105,
    "question": "Lees de tekst:\n\n\"Sommige planten eten insecten. De zonnedauw heeft kleverige druppels op zijn bladeren. Als een vlieg erop landt, blijft hij plakken. Dan sluit het blad zich langzaam.\"\n\nIn welke volgorde vangt de zonnedauw een vlieg?\n1. Het blad sluit zich\n2. De vlieg landt op het blad\n3. De vlieg blijft plakken",
    "options": [
      "2 → 3 → 1",
      "1 → 2 → 3",
      "3 → 1 → 2",
      "2 → 1 → 3"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tekstbegrip",
    "subSkill": "volgorde",
    "familyId": "TB-ZONNEDAUW",
    "explanation": "Eerst landt de vlieg (2), dan blijft hij plakken (3), dan sluit het blad zich (1).",
    "distractorExplanations": {
      "1": "Het blad sluit pas als laatste.",
      "2": "De vlieg moet eerst landen voordat hij kan plakken.",
      "3": "Het blad sluit niet voordat de vlieg landt."
    }
  },
  {
    "id": "TB-E6-010",
    "module": "Taalbegrip",
    "difficulty": 105,
    "question": "Lees de tekst:\n\n\"Mieren zijn ongelooflijk sterk. Ze kunnen wel 50 keer hun eigen gewicht tillen. Dat is alsof jij een auto zou optillen!\"\n\nWaarom noemt de schrijver het voorbeeld van de auto?",
    "options": [
      "Om duidelijk te maken hoe sterk mieren zijn vergeleken met mensen",
      "Omdat mieren auto's kunnen tillen",
      "Omdat kinderen van auto's houden",
      "Om te laten zien dat auto's zwaar zijn"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tekstanalyse",
    "subSkill": "doel_schrijver",
    "familyId": "TB-MIEREN-AUTO",
    "explanation": "De schrijver gebruikt de vergelijking met een auto om het begrijpelijk te maken. 50 keer je eigen gewicht is abstract; een auto optillen is concreet.",
    "distractorExplanations": {
      "1": "Mieren tillen geen auto's, het is een vergelijking.",
      "2": "De tekst gaat niet over wat kinderen leuk vinden.",
      "3": "Het doel is niet om te laten zien dat auto's zwaar zijn, maar hoe sterk mieren zijn."
    }
  }
]